module.exports = __webpack_public_path__ + "img/gb9877_1-88-70x90x10.prt.efbdcfd4.jpg";